import { ThaWeb } from '@RHEnvironmental/pattern-library-tokens';
import React, { useContext, createContext, } from 'react';
const TokenContext = createContext(ThaWeb);
export const TokenProvider = ({ children }) => (React.createElement(TokenContext.Provider, { value: ThaWeb }, children));
export const useTokens = () => useContext(TokenContext);
